export const ratingToValue = { 1: 0.33, 3: 0.5, 5: 1 };

export const ratingToText = { 1: "basic", 3: "intermediate", 5: "advanced" };

export const coreSkillsLimit = 6;

export const developmentalSkillsLimit = 5;
